module.exports = __webpack_public_path__ + "assets/img/like.2eabbfee.svg";